'use client';

import Link from '@eliadmin/core/src/components/link';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function ProfileFormWarning() {
  const { t } = useTranslations();

  return (
    <div className="col-span-12 flex w-full flex-col items-start justify-start gap-3 rounded-[4px] bg-primary-foreground p-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4 lg:gap-8">
      <div className="flex w-full flex-col items-start justify-start gap-2">
        <Heading title={t('text556')} tag="h6" />
        <Paragraph className="w-full" size="base" color="black">
          {t('text3708')}
        </Paragraph>
      </div>
      <Button asChild className="h-10 w-full whitespace-nowrap sm:w-fit">
        <Link href={ROUTES.CONTACT()}>{t('text186')}</Link>
      </Button>
    </div>
  );
}
